var __defProp = Object.defineProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
__export(exports, {
  ValidationTypes: () => ValidationTypes
});
var ValidationTypes;
(function(ValidationTypes2) {
  ValidationTypes2["CADASTER_NUMBER"] = "Cadaster_number";
  ValidationTypes2["CHECKBOX"] = "Checkbox";
  ValidationTypes2["CIF"] = "CIF";
  ValidationTypes2["DATE"] = "Date";
  ValidationTypes2["DECIMAL"] = "Decimal";
  ValidationTypes2["INTEGER"] = "Integer";
  ValidationTypes2["NIE"] = "NIE";
  ValidationTypes2["NIF"] = "NIF";
  ValidationTypes2["NIF_NIE"] = "NIF_NIE";
  ValidationTypes2["NIF_NIE_CIF"] = "NIF_NIE_CIF";
  ValidationTypes2["SINGLEOPTION"] = "Singleoption";
  ValidationTypes2["TEXT"] = "Text";
  ValidationTypes2["STRICT_TEXT"] = "StrictText";
  ValidationTypes2["ADDRESS"] = "Address";
})(ValidationTypes || (ValidationTypes = {}));
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ValidationTypes
});
